import React, { useMemo } from 'react';
import { Tag } from 'antd';
import { getInferenceStatus } from '../../lib/util/status';
import { CustomLink } from '../../components/CustomLink';
import { InferenceFile } from '../../types';
import { useTranslation } from 'react-i18next';

export const GetPublicDemoTableColumns = (onClickUrl: (inference: InferenceFile) => any) => {
  const { t } = useTranslation();

  const cols = useMemo(
    () => [
      {
        title: t('public.table.name'),
        key: 'fileName',
        dataIndex: 'fileName',
        render: (text: string, record: InferenceFile) => (
          <span style={{ width: '100%', overflow: 'hidden' }}>
            <CustomLink
              style={{ marginRight: '16px' }}
              disabled={record.status === 'PROCESSING'}
              onClickUrl={onClickUrl(record)}>
              {text}
            </CustomLink>
          </span>
        ),
      },
      {
        title: t('public.table.status'),
        key: 'status',
        dataIndex: 'status',
        render: (text: string, record: InferenceFile) => (
          <span>
            <Tag color={getInferenceStatus(record).color} key={'READY'}>
              {t(`general.status.${getInferenceStatus(record).label}`)}
            </Tag>
          </span>
        ),
      },
    ],
    [t, onClickUrl]
  );
  return cols;
};
